"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.number.is-integer");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// 判断是否为字符串
function isString(source) {
  return typeof source === 'string' || !!source && _typeof(source) === 'object' && Object.prototype.toString.call(source) === '[object String]';
} // 判断是否为数组


function isArray(source) {
  return Array.isArray(source);
} // 判断是否为纯对象


function isObject(source) {
  return Object.prototype.toString.call(source) === '[object Object]';
} // 判断是否为函数


function isFunction(source) {
  return source != null && (source.constructor === Function || source instanceof Function);
} // 判断是否为数字


function isNumber(source) {
  return source != null && (source.constructor === Number || source instanceof Number);
} // 判断是否为整数


function isInt(source) {
  return Number.isInteger(source);
} // 判断是否等于null或者undefined


function isNill(source) {
  return source == null;
}

var _default = {
  isString: isString,
  isArray: isArray,
  isObject: isObject,
  isFunction: isFunction,
  isNumber: isNumber,
  isInt: isInt,
  isNill: isNill
};
exports.default = _default;